import { InputFieldV5, TextareaV5 } from "components/form";

const INPUT_FIELDS = [
  {
    name: "date",
    group: "common",
    type: "date",
    icon: "far fa-calendar-alt",
    className: "input ",
    component: InputFieldV5,
    required: false,
    userCanEdit: true,
  },
  {
    name: "time",
    group: "common",
    type: "time",
    icon: "far fa-clock",
    className: "input ",
    component: InputFieldV5,
    required: false,
    userCanEdit: true,
  },
  {
    name: "subject",
    group: "common",
    type: "text",
    icon: "fas fa-heart",
    className: "input ",
    component: InputFieldV5,
    required: false,
    userCanEdit: true,
  },
  {
    name: "body",
    group: "stableDiary",
    type: "text",
    className: "textarea ",
    component: TextareaV5,
    rows: 5,
    required: false,
    charLimit: 500,
    userCanEdit: true,
  },
];

export { INPUT_FIELDS };
